import React, { Component } from 'react';
import Popup from './popup';

class PreviewSOA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
            agentDetails: props.agentDetails
        }
    }

    selPrvw() {
        console.log("Preview");
        this.setState({
            showPopup: true
        });
    }

    onSubmit() {
        this.props.getResult();
    }

    getPopupResult() {
        this.setState({
            showPopup: false
        });
    }

    render() {
        return (
            <div>
                <section>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 pm_landingview">
                                <div>
                                    <h3>Please review the agent information before signing the document.</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="pm_hm_article  dividershade pm_hm_article1">
                    <div className="container">
                        <div className="row dividershade">
                            <div className="col-md-6"><h2>Agent Information</h2>
                                {/* <p>Agent Name  :  <span>Mark</span></p><p>Agent Phone  :  <span>+970 20 4810 33</span></p><p>Agent Email-Id  : <span>agent@producermax.com</span></p> */}
                                <div className="row">
                                    <div className="col col-lg-3 agediv mb-1">
                                        <img className="img-fluid" src={this.state.agentDetails.AgentPhotoServerPath != "" ? this.state.agentDetails.AgentPhotoServerPath : './images/profile-pic.png'} />
                                    </div>
                                    <div className="col col-lg-8 " style={{ "text-align": "left", "font-size": "15px" }}>
                                        <p className="agentName">Name  :  <span>{this.state.agentDetails.AgentFullName}</span></p>
                                        <p>Phone  :  <span>{this.state.agentDetails.AgentPhone}</span></p>
                                        <p>Email-Id  : <span><a href={"mailto:" + this.props.agentDetails.AgentEmail}>{this.state.agentDetails.AgentEmail}</a></span></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <h2>Preview Sample SOA</h2>
                                {/* <center><a href={pdf} target="_blank" onClick={this.selPrvw.bind(this)} data-lightbox="photos"><img className="img-fluid" src={I} /></a></center> */}
                                <center><a onClick={this.selPrvw.bind(this)} data-lightbox="photos"><img className="img-fluid" src={'./images/v3.png'} /></a></center>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="pm_hm_article pm_hm_article1">
                    <div className="container">
                    </div>
                    <div className="row">
                        {/* <a href="#" className="pm_landingview_btn"><span>CLICK TO SIGN</span></a> */}
                        <button type="submit" onClick={this.onSubmit.bind(this)} className="pm_landingview_btn"><span>CLICK TO PROCEED</span></button>
                    </div>
                    <div className="row notAgent">
                        {/* <a href="#" className="pm_landingview_btn"><span>CLICK TO SIGN</span></a> */}
                        <h5>If not your agent, close the browser</h5>
                    </div>
                </section>

                {this.state.showPopup ?
                    <Popup
                        getResult={this.getPopupResult.bind(this)}
                        pageNum={1}
                    />
                    : null
                }
            </div>
        );
    }
}

export default PreviewSOA;